import React from 'react';
import { motion } from 'framer-motion';
import { FaClock, FaRocket, FaTools } from 'react-icons/fa';
import AdminPageHeader from './AdminPageHeader';

const ComingSoon = ({ title = 'Coming Soon', subtitle = 'This feature is under development' }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminPageHeader 
        title={title}
        subtitle={subtitle}
        icon={<FaClock className="w-6 h-6" />}
      />
      
      <div className="pt-32 pb-12 px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mx-auto"
        >
          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-12 text-center">
            {/* Animated Icon */}
            <motion.div
              animate={{ 
                rotate: [0, 10, -10, 0],
                scale: [1, 1.1, 1]
              }}
              transition={{ 
                duration: 2,
                repeat: Infinity,
                repeatDelay: 1
              }}
              className="inline-block mb-6"
            >
              <div className="w-24 h-24 bg-gradient-to-br from-orange-100 via-pink-100 to-purple-100 rounded-full flex items-center justify-center border-4 border-gray-100">
                <FaRocket className="w-12 h-12 text-orange-400" />
              </div>
            </motion.div>

            {/* Title */}
            <h2 className="text-4xl font-bold text-gray-800 mb-4">
              Coming Soon
            </h2>

            {/* Description */}
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              We're working hard to bring you this feature. It will be available soon!
            </p>

            {/* Features List */}
            <div className="bg-gray-50 rounded-xl p-6 mb-8 text-left">
              <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                <FaTools className="w-5 h-5 mr-2 text-orange-400" />
                What to Expect
              </h3>
              <ul className="space-y-3">
                <motion.li
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.2 }}
                  className="flex items-start"
                >
                  <span className="text-orange-400 mr-3 mt-1">✓</span>
                  <span className="text-gray-700">Enhanced functionality and user experience</span>
                </motion.li>
                <motion.li
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.3 }}
                  className="flex items-start"
                >
                  <span className="text-orange-400 mr-3 mt-1">✓</span>
                  <span className="text-gray-700">Streamlined workflow and management tools</span>
                </motion.li>
                <motion.li
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.4 }}
                  className="flex items-start"
                >
                  <span className="text-orange-400 mr-3 mt-1">✓</span>
                  <span className="text-gray-700">Modern design matching the latest standards</span>
                </motion.li>
              </ul>
            </div>

            {/* Progress Bar */}
            <div className="mb-6">
              <div className="flex justify-between text-sm text-gray-600 mb-2">
                <span>Development Progress</span>
                <span>In Progress</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
                <motion.div
                  initial={{ width: 0 }}
                  animate={{ width: '65%' }}
                  transition={{ duration: 1.5, ease: "easeOut" }}
                  className="h-full bg-gradient-to-r from-orange-400 via-pink-400 to-purple-400 rounded-full"
                />
              </div>
            </div>

            {/* Footer Message */}
            <p className="text-sm text-gray-500">
              Stay tuned for updates! We'll notify you when this feature is ready.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ComingSoon;

